import { useState, FormEvent } from 'react';
import { AccessDeniedLayout, Content, LockIcon } from './AccessDeniedLayout';
import Textarea from '../Textarea/Textarea';
import Button from '../Button/Button';

type AccessDeniedWithRequestProps = {
    title?: string;
    contentTitle?: string;
    subtitle?: string;
    subtitle2?: string;
    onSubmit: (message: string) => void;
    submitLabel?: string;
    messageRequired?: boolean;
    messagePlaceholder?: string;
    formDisabled?: boolean;
};
export default function AccessDeniedWithRequest({
    title,
    contentTitle,
    subtitle,
    subtitle2,
    onSubmit,
    submitLabel,
    messageRequired = true,
    messagePlaceholder,
    formDisabled,
}: AccessDeniedWithRequestProps) {
    const [input, setInput] = useState('');
    const [loading, setLoading] = useState(false);

    // no error handling here only loading state
    const finalOnSubmit = async (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setLoading(true);
        try {
            await onSubmit(input);
        } finally {
            setLoading(false);
        }
    };
    const disabled = formDisabled || loading;

    return (
        <AccessDeniedLayout title={title}>
            <div className="alli-mx-auto alli-mt-40 alli-w-full sm:alli-w-4/5 md:alli-w-3/5 xl:alli-w-1/3">
                <div className="w-full alli-flex alli-flex-row">
                    <LockIcon />
                    <form
                        className="alli-ml-0 alli-mt-6 alli-grow alli-text-left sm:alli-ml-12 sm:alli-mt-0"
                        onSubmit={finalOnSubmit}>
                        <Content
                            title={contentTitle}
                            subtitle={subtitle}
                            subtitle2={subtitle2}
                            accessType={'accessDeniedWithRequest'}
                        />
                        <Textarea
                            name="message"
                            placeholder={
                                messagePlaceholder ||
                                (messageRequired
                                    ? 'Message'
                                    : 'Message (optional)')
                            }
                            className="alli-xs:h-32 w-full alli-mb-4 alli-mt-2 alli-resize-none"
                            onChange={e => setInput(e.target.value)}
                            value={input}
                            required={messageRequired}
                            disabled={disabled}
                        />
                        <Button
                            type="submit"
                            loading={loading}
                            disabled={disabled}>
                            {submitLabel || 'Request Access'}
                        </Button>
                    </form>
                </div>
            </div>
        </AccessDeniedLayout>
    );
}
